import React from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

const whatsappUrl = 'https://wa.me/916263618884?text=Hi%2C%20I%20want%20a%20demo%20of%20SpellStudy%20for%20my%20school.';

const LaunchBanner = () => {
  const { t } = useTranslation();

  const scrollToDemo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="lp-launch-banner">
      <div className="lp-container lp-launch-banner-inner">
        <div className="lp-launch-copy">
          <i className="fa-solid fa-bullhorn" />
          <span>{t('landing.launch.offer')}</span>
        </div>
        <div className="lp-launch-actions">
          <button type="button" onClick={scrollToDemo}>{t('landing.launch.bookDemo')}</button>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">{t('landing.launch.whatsAppDemo')}</a>
        </div>
      </div>
    </div>
  );
};

export default LaunchBanner;
